module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"primary":"Primary","accent":"Accent","background":"Background"},"es":{"primary":"Primario","accent":"Énfasis","background":"Fondo"}}')
  delete Component.options._Ctor
}
